// @flow
import { actions as rtiActions } from 'state/reducers/rtiReducer';
import type { Dispatch, GetState } from 'state/types';
import logger from 'portfolio-shared/util/logging';
import { getAdminSession } from 'state/selectors';

const { getRTI: getRTIAction, rtiToggle: rtiToggleAction } = rtiActions;

export function getRTI() {
  return async function getRTI(dispatch: Dispatch, getState: GetState) {
    const adminSessionId = getAdminSession(getState());

    await dispatch(getRTIAction(adminSessionId)).catch(e => {
      logger.debug('Error: failed to get RTI status.', e);
    });
  };
}

export function rtiToggle(value: boolean) {
  return async function rtiToggle(dispatch: Dispatch, getState: GetState) {
    const adminSessionId = getAdminSession(getState());

    await dispatch(rtiToggleAction(adminSessionId, value)).catch(e => {
      logger.debug('Error: failed to toggle RTI status.', e);
    });
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/rtiCommands.js